import { XIcon } from "@heroicons/react/solid";
import React from "react";
import ReactModal, {
  defaultStyles,
  Props as ReactModalProps,
} from "react-modal";

const baseStyles = {
  content: {
    padding: 0,
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    border: "none",
  },

  overlay: {
    ...defaultStyles.overlay,
    backgroundColor: "rgba(0, 0, 0, 0.75)",
  },
};

const Modal = ({
  children,
  style,
  ...props
}: ReactModalProps & { children: React.ReactNode }) => {
  return (
    <ReactModal {...props} style={{ ...baseStyles, ...style }}>
      {children}
    </ReactModal>
  );
};

export const ModalCloseButton = ({
  onRequestClose,
}: {
  onRequestClose: () => void;
}) => {
  return (
    <button
      className="absolute top-4 right-4 text-gray-400 w-6 h-6 hover:text-green-600 transition-colors"
      onClick={() => {
        onRequestClose();
      }}
    >
      <XIcon />
    </button>
  );
};

export default Modal;
